"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.reflect.get");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.repeat");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.replace");

var _vanillaTextMask = require("vanilla-text-mask");

var _lodash = _interopRequireDefault(require("lodash"));

var _textMaskAddons = require("text-mask-addons");

var _Base = _interopRequireDefault(require("../base/Base"));

var _utils = require("../../utils/utils");

var _WithLogic2 = _interopRequireDefault(require("../../utils/WithLogic"));

var _Validator = _interopRequireDefault(require("../Validator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NumberComponent =
/*#__PURE__*/
function (_WithLogic) {
  _inherits(NumberComponent, _WithLogic);

  _createClass(NumberComponent, null, [{
    key: "schema",
    value: function schema() {
      for (var _len = arguments.length, extend = new Array(_len), _key = 0; _key < _len; _key++) {
        extend[_key] = arguments[_key];
      }

      return _Base.default.schema.apply(_Base.default, [{
        type: 'number',
        label: 'Number',
        key: 'number',
        validate: {
          min: '',
          max: '',
          step: 'any',
          integer: ''
        }
      }].concat(extend));
    }
  }, {
    key: "builderInfo",
    get: function get() {
      return {
        title: 'Number',
        icon: 'fa fa-hashtag',
        group: 'basic',
        documentation: 'http://help.form.io/userguide/#number',
        weight: 10,
        schema: NumberComponent.schema()
      };
    }
  }]);

  function NumberComponent(component, options, data) {
    var _this;

    _classCallCheck(this, NumberComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NumberComponent).call(this, component, options, data));

    _defineProperty(_assertThisInitialized(_this), "componentCache", {
      userInput: null
    });

    _this.calculateWithDebounce = _lodash.default.debounce(_this.calculate.bind(_assertThisInitialized(_this)), 500);
    _this.validators = _this.validators.concat(['min', 'max']);
    var separators = (0, _utils.getNumberSeparators)(_this.options.language);
    _this.decimalSeparator = _this.options.decimalSeparator = _this.options.decimalSeparator || separators.decimalSeparator;

    if (_this.component.delimiter) {
      if (_this.options.hasOwnProperty('thousandsSeparator')) {
        console.warn("Property 'thousandsSeparator' is deprecated. Please use i18n to specify delimiter.");
      }

      _this.delimiter = _this.component.useSeparator || _this.options.thousandsSeparator || separators.delimiter;
    } else {
      _this.delimiter = '';
    } // Установка разделительного символа для разрядов


    if (_this.component.useSeparator) {
      _this.delimiter = ' ';
    }

    _this.decimalLimit = (0, _utils.getNumberDecimalLimit)(_this.component); // Currencies to override BrowserLanguage Config. Object key {}

    if (_lodash.default.has(_this.options, "languageOverride.".concat(_this.options.language))) {
      var override = _lodash.default.get(_this.options, "languageOverride.".concat(_this.options.language));

      _this.decimalSeparator = override.decimalSeparator;
      _this.delimiter = override.delimiter;
    }

    _this.numberMask = (0, _textMaskAddons.createNumberMask)({
      prefix: '',
      suffix: '',
      requireDecimal: _lodash.default.get(_this.component, 'requireDecimal', false),
      thousandsSeparatorSymbol: _lodash.default.get(_this.component, 'thousandsSeparator', _this.delimiter),
      decimalSymbol: _lodash.default.get(_this.component, 'decimalSymbol', _this.decimalSeparator),
      decimalLimit: _lodash.default.get(_this.component, 'decimalLimit', _this.decimalLimit),
      allowNegative: _lodash.default.get(_this.component, 'allowNegative', true),
      allowDecimal: _lodash.default.get(_this.component, 'allowDecimal', !(_this.component.validate && _this.component.validate.integer))
    });
    return _this;
  }
  /**
   * @override метода из BaseComponent.
   * Инициирует перерисовку компонента.
   * @param shouldRedrawInBuilder Boolean. Нужна ли перересовка до билда компонента.
   */


  _createClass(NumberComponent, [{
    key: "redraw",
    value: function redraw(shouldRedrawInBuilder) {
      // Don't bother if we have not built yet.
      if (!this.isBuilt || !shouldRedrawInBuilder && this.options.builder) {
        return;
      } // Если флаг "Валидация по сложению" поставлен, то ребилд происходит без сброса состояния компонента.
      // Если нет - то, соответственно, со сбросом.


      if (this.component.validateReactively) {
        this.build();
      } else {
        this.build(this.clear());
      }
    }
    /**
     * @override метода из BaseComponent.
     * Returns the invalid message, or empty string if the component is valid.
     * @param data
     * @param dirty
     * @param ignoreCondition
     * @return {*}
     */

  }, {
    key: "invalidMessage",
    value: function invalidMessage(data, dirty, ignoreCondition) {
      if (this.component.validateReactively) {
        return _Validator.default.check(this, data);
      } else {
        // Force valid if component is conditionally hidden.
        if (!ignoreCondition && !this.checkCondition(null, data)) {
          return '';
        } // See if this is forced invalid.


        if (this.invalid) {
          return this.invalid;
        } // No need to check for errors if there is no input or if it is pristine.


        if (!this.hasInput || !dirty && this.pristine) {
          return '';
        }

        return _Validator.default.check(this, data);
      }
    }
  }, {
    key: "parseNumber",
    value: function parseNumber(value) {
      // Remove delimiters and convert decimal separator to dot.
      value = value.split(this.delimiter).join('').replace(this.decimalSeparator, '.');

      if (this.component.validate && this.component.validate.integer) {
        return parseInt(value, 10);
      } else {
        return parseFloat(value);
      }
    }
  }, {
    key: "refresh",
    value: function refresh(value) {
      if (this.component.clearOnRefresh) {
        this.setValue(null);
      }

      this.triggerRedraw();
    }
  }, {
    key: "setInputMask",
    value: function setInputMask(input) {
      input.setAttribute('pattern', '\\d*');
      input.mask = (0, _vanillaTextMask.maskInput)({
        inputElement: input,
        mask: this.numberMask
      });
    }
  }, {
    key: "setSum",
    value: function setSum() {
      var calculateValue = ["value = "];

      if (!this.component.floatDegree) {
        this.component.floatDegree = 0;
      }

      var floatDegree = this.component.floatDegree;
      this.component.numberFields.forEach(function (numberField) {
        var firstChar = calculateValue.length >= 2 ? '+' : '';
        var field = numberField.field;

        if (field.includes('.')) {
          var _field$split = field.split('.'),
              _field$split2 = _slicedToArray(_field$split, 2),
              editGridName = _field$split2[0],
              fieldName = _field$split2[1];

          calculateValue.push("".concat(firstChar, " data.").concat(editGridName, ".map((value) => value.").concat(fieldName, ").reduce((previousValue, currentValue) => previousValue + currentValue)"));
        } else {
          calculateValue.push("".concat(firstChar, " data.").concat(field));
        }
      });
      var multiplierDegree = floatDegree < 6 ? 6 : floatDegree;
      var multiplier = Math.pow(10, multiplierDegree);
      var epsilon = Math.pow(2, -52);
      var roundedValue = "value = Math.round((value + ".concat(epsilon, ") * ").concat(multiplier, ") / ").concat(multiplier, ";");
      var script = "".concat(calculateValue.join(' '), "; ").concat(roundedValue);
      this.component.calculateValue = script;
    }
  }, {
    key: "updateValue",
    value: function updateValue(flags, value) {
      if (!this.hasInput) {
        return false;
      }

      flags = flags || {};
      var newValue = value;

      if (!this.visible && this.component.clearOnHide) {
        newValue = this.dataValue;
      } else if (_lodash.default.isNil(value)) {
        newValue = this.getValue(flags);
      }

      if (newValue !== 0) {
        newValue = newValue ? newValue : null;
      } // Включаем кеширование через флаг чекбокса "Валидация по сложению"


      if (this.component.validateReactively) {
        // Кешируем значение, потому что этот метод (updateValue) крутится через бесконечный луп. (можно проверить логами)
        if (this.componentCache.userInput === newValue) {
          return;
        } else {
          this.componentCache.userInput = newValue;
        }
      }

      var changed = this.hasChanged(newValue, this.dataValue);
      this.dataValue = newValue;

      if (this.viewOnly) {
        this.updateViewOnlyValue(newValue);
      }

      this.updateOnChange(flags, changed);
      return changed;
    }
  }, {
    key: "calculateValue",
    value: function calculateValue(data, flags) {
      if (this.component.allowCalculateOverride) {
        this.calculateWithDebounce(data, flags);
      } else {
        this.calculate(data, flags);
      }
    }
  }, {
    key: "elementInfo",
    value: function elementInfo() {
      var info = _get(_getPrototypeOf(NumberComponent.prototype), "elementInfo", this).call(this);

      info.attr.type = 'text';
      info.attr.inputmode = 'numeric';
      info.changeEvent = 'input';
      return info;
    }
  }, {
    key: "getValueAt",
    value: function getValueAt(index) {
      if (!this.inputs.length || !this.inputs[index]) {
        return null;
      }

      var val = this.inputs[index].value;

      if (!val) {
        return undefined;
      }

      return this.parseNumber(val);
    }
  }, {
    key: "clearInput",
    value: function clearInput(input) {
      var value = parseFloat(input);

      if (!_lodash.default.isNaN(value)) {
        value = String(value).replace('.', this.decimalSeparator);
      } else {
        value = null;
      }

      return value;
    }
  }, {
    key: "formatValue",
    value: function formatValue(value) {
      if (this.component.requireDecimal && value && !value.includes(this.decimalSeparator)) {
        return "".concat(value).concat(this.decimalSeparator).concat(_lodash.default.repeat('0', this.decimalLimit));
      } else if (this.component.requireDecimal && value && value.includes(this.decimalSeparator)) {
        return "".concat(value).concat(_lodash.default.repeat('0', this.decimalLimit - value.split(this.decimalSeparator)[1].length), ")}");
      }

      return value;
    }
  }, {
    key: "setValueAt",
    value: function setValueAt(index, value) {
      value = this.formatValue(this.clearInput(value));

      if (_lodash.default.isNil(value)) {
        value = this.defaultValue;

        if (!this.component.multiple && value !== null && Array.isArray(value)) {
          value = value[0];
        }
      }

      var input = this.performInputMapping(this.inputs[index]);

      if (input.mask && !this.component.multiple) {
        input.mask.textMaskInputElement.update(value);
      } else {
        input.value = value;
      }

      if (input.widget) {
        input.widget.setValue(value);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      var input = this.inputs[0];

      if (input) {
        input.focus();
        input.setSelectionRange(0, input.value.length);
      }
    }
  }, {
    key: "getMaskedValue",
    value: function getMaskedValue(value) {
      var _value = value.toString().replace('.', this.decimalSeparator);

      return (0, _vanillaTextMask.conformToMask)(_value.toString(), this.numberMask).conformedValue;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty(value) {
      var _this2 = this;

      var isEmpty = true;

      if (Array.isArray(value)) {
        var isNotEmpty = value.some(function (number) {
          return !(isNaN(number) || _get(_getPrototypeOf(NumberComponent.prototype), "isEmpty", _this2).call(_this2, number));
        });
        isEmpty = !isNotEmpty;
      } else {
        isEmpty = isNaN(value) || _get(_getPrototypeOf(NumberComponent.prototype), "isEmpty", this).call(this, value);
      }

      return isEmpty;
    }
    /** @override **/

  }, {
    key: "createInput",
    value: function createInput() {
      var _get2,
          _this3 = this;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var input = (_get2 = _get(_getPrototypeOf(NumberComponent.prototype), "createInput", this)).call.apply(_get2, [this].concat(args));

      if (this.component.requireDecimal) {
        this.addEventListener(input, 'blur', function () {
          var index = _this3.inputs.indexOf(input);

          if (index !== -1) {
            _this3.setValueAt(index, _this3.getValueAt(index));
          }
        });
      }

      return input;
    }
  }, {
    key: "getView",
    value: function getView(value) {
      var _this4 = this;

      if (!value && value !== 0) {
        return '';
      }

      if (Array.isArray(value)) {
        var values = value.filter(function (number) {
          return !_lodash.default.isNil(number);
        });
        return values.map(function (number) {
          return _this4.getMaskedValue(number);
        }).join(', ');
      }

      value = +value; // добавлено явно, для избежания ошибок с лишними нулями

      var widget = this.widget;

      if (widget && widget.getView) {
        return widget.getView(value);
      }

      var maskedValue = this.getMaskedValue(value);
      var decimalLimit = this.component.decimalLimit;

      if (this.component.requireDecimal && decimalLimit && maskedValue.slice(-1) === this.decimalSeparator) {
        maskedValue += '0'.repeat(decimalLimit);
      }

      return maskedValue;
    }
  }, {
    key: "build",
    value: function build(state) {
      state = state || {};
      this.calculatedValue = state.calculatedValue;

      if (this.viewOnly) {
        this.viewOnlyBuild();
      } else {
        this.createElement();
        var labelAtTheBottom = this.component.labelPosition === 'bottom';

        if (!labelAtTheBottom) {
          this.createLabel(this.element);
        }

        if (!this.createWrapper()) {
          this.createInput(this.element);
        }

        if (labelAtTheBottom) {
          this.createLabel(this.element);
        }

        this.createDescription(this.element);

        if (this.component.calculate && !this.component.allowCalculateOverride) {
          this.component.disabled = true;
        }

        if (this.component.allowCalculateOverride) {
          this.component.disabled = false;
        } // Disable if needed.


        if (this.shouldDisable) {
          this.disabled = true;
        } // Restore the value.


        this.restoreValue(); // Attach the refresh on events.

        if (!this.component.validateReactively) {
          this.attachRefreshOn();
        }

        this.autofocus();
      }

      if (this.component.numberFields && !this.viewOnly) {
        this.setSum();
      }

      this.attachLogic();
    }
  }, {
    key: "buildInput",
    value: function buildInput(container, value) {
      if (value === undefined) {
        value = '';
      }

      var input = this.createInput(container);
      input.value = value;
    }
  }, {
    key: "restoreValue",
    value: function restoreValue() {
      if (this.hasSetValue) {
        this.setValue(this.dataValue, {
          noUpdateEvent: true
        });
      } else {
        var defaultValue = this.defaultValue;

        if (_typeof(defaultValue) === 'object') {
          defaultValue = null;
        }

        if (!_lodash.default.isNil(defaultValue)) {
          this.setValue('defaultValue', {
            noUpdateEvent: true
          });
        }
      }
    }
  }, {
    key: "calculate",
    value: function calculate(data, flags) {
      // If no calculated value or
      // hidden and set to clearOnHide (Don't calculate a value for a hidden field set to clear when hidden)
      if (!this.component.calculateValue || (!this.visible || this.component.hidden) && this.component.clearOnHide) {
        return false;
      } // Get the dataValue.


      var dataValue = null;
      var allowOverride = this.component.allowCalculateOverride;

      if (allowOverride) {
        dataValue = this.dataValue;
      } // First pass, the calculatedValue is undefined.


      if (this.calculatedValue === undefined) {
        this.calculatedValue = 0;
      }

      if (dataValue === undefined) {
        dataValue = 0;
      } // Check to ensure that the calculated value is different than the previously calculated value.


      if (allowOverride && this.calculatedValue !== null && this.calculatedValue !== this.emptyValue && !_lodash.default.isEqual(dataValue, this.calculatedValue)) {
        this.calculatedValue = dataValue;
        return false;
      } // Calculate the new value.


      var calculatedValue = this.evaluate(this.component.calculateValue, {
        value: this.defaultValue,
        data: data
      }, 'value');
      flags = flags || {};
      flags.noCheck = true;
      this.setValue(calculatedValue, flags);
      var changed = !_lodash.default.isEqual(dataValue, this.calculatedValue);

      if (changed === undefined) {
        changed = true;
      }

      this.calculatedValue = this.dataValue;
      return changed;
    }
  }, {
    key: "defaultSchema",
    get: function get() {
      return NumberComponent.schema();
    }
  }, {
    key: "defaultValue",
    get: function get() {
      var defaultValue = _get(_getPrototypeOf(NumberComponent.prototype), "defaultValue", this);

      if (!defaultValue && this.component.defaultValue === 0) {
        defaultValue = this.component.defaultValue;
      }

      return defaultValue;
    }
  }]);

  return NumberComponent;
}((0, _WithLogic2.default)(_Base.default));

exports.default = NumberComponent;